import { getDatabase, ref as fbRef } from 'firebase/database';
import { getDAMApp } from '../services/firebase';

const damApp = getDAMApp();
const damDatabase = getDatabase(damApp);
export const ref = (str) => fbRef(damDatabase, str);
